module.exports = __webpack_public_path__ + "img/A1 (9).8aec13b7.jpg";